var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-chip',{attrs:{"type":_vm.colour,"text":_vm.$t(("enums.remote_application_status." + _vm.status)),"large":_vm.large}})}
var staticRenderFns = []

export { render, staticRenderFns }